import { createContext, useContext, useState, useCallback, useRef } from 'react';

const NavbarCtx = createContext(null);

export function NavbarProvider({ children }) {
    const [activeId, setActiveId] = useState(null);
    const triggersRef = useRef({});

    const register = useCallback((id, triggerRef) => {
        triggersRef.current[id] = triggerRef;
    }, []);

    const open = useCallback((id) => {
        setActiveId((prev) => (prev === id ? null : id));
    }, []);

    const close = useCallback((id) => {
        setActiveId((prev) => {
            if (prev !== id) return prev;
            const el = triggersRef.current[id]?.current;
            if (el) requestAnimationFrame(() => el.focus());
            return null;
        });
    }, []);

    const closeAll = useCallback(() => setActiveId(null), []);

    return (
        <NavbarCtx.Provider value={{ activeId, open, close, closeAll, register }}>
            {children}
        </NavbarCtx.Provider>
    );
}

export function useNavbar(id) {
    const ctx = useContext(NavbarCtx);
    if (!ctx) return { isOpen: false, toggle: () => {}, close: () => {}, register: () => {} };
    return {
        isOpen: ctx.activeId === id,
        toggle: () => ctx.open(id),
        close: () => ctx.close(id),
        register: (ref) => ctx.register(id, ref),
    };
}
